import { render } from "./ViewParceiro.vue?vue&type=template&id=54835e59"
import script from "./ViewParceiro.vue?vue&type=script&lang=js"
export * from "./ViewParceiro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__